export default {
    imprint: 'Imprint',
    dataProtection: 'Privacy Policy',
    help: 'Hilfe',
    cookies: 'Cookies'
}
